import React from 'react';
import { Box, Container } from '@hover/blueprint';
import styled from '@emotion/styled';
import {
  HelpFulLinksTabletDesktop,
  Layout,
  StillHaveQuestions,
  BackToTopButton,
  UtilityMenuBanner,
} from '../../v2/components/common';
import { Hero } from '../../v2/components/cookie-policy';

const StyledDiv = styled.div`
  font-family: Adelle Sans, Work Sans, Open Sans, Helvetica Neue, Helvetica,
    Arial, sans-serif;

  #cookie-policy-description {
    margin-bottom: 2rem !important;
  }

  h4 {
    margin-bottom: 1rem !important;
  }

  section {
    margin-bottom: 3rem !important;
  }

  td {
    inline-size: min-content;

    span {
      max-width: 300px;
      word-break: break-all;
    }
  }
`;

const CookiePolicy: React.FC = () => (
  <Layout
    navbarBackgroundColor="brandBrown.100"
    isNavbarWhite={false}
    titleColor="neutral.900"
    title="Cookie policy"
    bannerElement={<UtilityMenuBanner />}
  >
    <Hero />
    <Container
      maxW="100%"
      position="relative"
      overflow="visible"
      px={{ base: 100, tablet: 500 }}
      centerContent
    >
      <Box w="100%" maxW="1200px">
        <Box
          h="418px"
          w="276px"
          zIndex={1}
          d={{ base: 'none', tablet: 'block' }}
          position="sticky"
          top="20vh"
          mb="82px"
        >
          <HelpFulLinksTabletDesktop />
        </Box>
        <Box
          maxW="760px"
          w="100%"
          ml={{ base: 0, tablet: '80px', desktop: '130px' }}
          flexDir="column"
          mb={1000}
        >
          <StyledDiv id="ot-sdk-cookie-policy" />
        </Box>
      </Box>
    </Container>
    <StillHaveQuestions />
    <BackToTopButton />
  </Layout>
);

export default CookiePolicy;
